import React, { useContext, useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import ProportionBar from '../../../../../../shared/components/v3/Charts/ProportionBar/ProportionBar';
import BdsDivider from '../../../../../../shared/components/v3/Globals/BdsDivider/BdsDivider';
import { CompanyContext } from '../../../../../../shared/context/company/companyContext';
import { IHealthReport } from '../../../../../../shared/interfaces/reports';
import { TRANSLATIONS_REPORTS } from '../../../../../../shared/translations/reports';
import { toLocaleNumberFormat } from '../../../../../../shared/utils/utils';

import './RefundData.scss';

export const RefundData = ({ data, inDownloadMode }: { data: IHealthReport; inDownloadMode?: boolean }) => {
  const { locale } = useContext(CompanyContext);
  const { t } = useTranslation();

  const proportionBarData = useMemo(() => {
    if (!data?.savingsData) return [];
    return data.savingsData.map((item) => ({
      label: item.label,
      value: item.value
    }));
  }, [data]);

  const formattedTotalSavingsAmount = useMemo(
    () =>
      toLocaleNumberFormat(
        data.totalSavingsAmount,
        { style: 'currency', currency: data.currency, maximumFractionDigits: 0 },
        locale || undefined
      ),
    [data.totalSavingsAmount, locale, data.currency]
  );

  return (
    <div className="refund-data-container">
      <div className="health-report-section-subtitle">{t(TRANSLATIONS_REPORTS.healthReport.refundData.title)}</div>
      <div className="rd-info">
        <div className="rd-info-item">
          <div className="rd-info-value">{data.totalClaims}</div>
          <div className="rd-info-label">{t(TRANSLATIONS_REPORTS.healthReport.refundData.totalClaimsLabel)}</div>
        </div>
        <div className="rd-info-item">
          <div className="rd-info-value">{formattedTotalSavingsAmount}</div>
          <div className="rd-info-label">{t(TRANSLATIONS_REPORTS.healthReport.refundData.totalSavingsLabel)}</div>
        </div>
      </div>
      {proportionBarData.length > 0 && (
        <div className="rd-savings-chart">
          <ProportionBar data={proportionBarData} isStatic={inDownloadMode} />
        </div>
      )}
      <div className="rd-info">
        <div className="rd-info-item">
          <div className="rd-info-value">{`${data.approvedClaims}%`}</div>
          <div className="rd-info-label">{t(TRANSLATIONS_REPORTS.healthReport.refundData.approvedClaimsLabel)}</div>
        </div>
        <div className="rd-info-item">
          <div className="rd-info-value">{`${data.imedRate}%`}</div>
          <div className="rd-info-label">{t(TRANSLATIONS_REPORTS.healthReport.refundData.imedRateLabel)}</div>
        </div>
      </div>
      <BdsDivider size="s" color="high" />
    </div>
  );
};

export default RefundData;
